// platform/src/components/mw/MwFooter.tsx

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { MwLogo } from './MwLogo'
import { usePlatformSettings } from '@/hooks/usePlatformSettings'

export function MwFooter() {
  const { t } = useTranslation('mw')

  const { canBuyDirect, showsBusiness } = usePlatformSettings()

  const links = [
    { label: t('footer.diagnostic'), href: '/diagnostico' },
    { label: t('footer.calculators'), href: '/calculadoras' },
  ]

  if (canBuyDirect) {
    links.push({ label: t('footer.pricing'), href: '/comprar' })
  }
  if (showsBusiness) {
    links.push({ label: t('footer.companies'), href: '/empresas' })
  }

  // La politica es publica: /cuenta/privacidad son los ajustes de
  // la cuenta y exige sesion, asi que un visitante acababa en el
  // muro de acceso.
  links.push({ label: t('footer.privacy'), href: '/privacidad' })

  return (
    <footer
      style={{
        background: 'var(--mw-surface)',
        borderTop: '1px solid var(--mw-border)',
      }}
    >
      <div style={{ maxWidth: "var(--mw-w-page)", margin: "0 auto", padding: "32px var(--mw-p-page)" }}>
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <MwLogo size="sm" />
          <nav className="flex flex-wrap gap-x-5 gap-y-2">
            {links.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                style={{
                  fontFamily: 'var(--mw-font-body)',
                  fontSize: 13,
                  color: 'var(--mw-ink-secondary)',
                  textDecoration: 'none',
                }}
                onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => { e.currentTarget.style.color = 'var(--mw-ink)' }}
                onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => { e.currentTarget.style.color = 'var(--mw-ink-secondary)' }}
              >
                {l.label}
              </Link>
            ))}
            <a
              href="mailto:hola@plainvanilla.ai"
              style={{
                fontFamily: 'var(--mw-font-body)',
                fontSize: 13,
                color: 'var(--mw-ink-secondary)',
                textDecoration: 'none',
              }}
              onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => { e.currentTarget.style.color = 'var(--mw-ink)' }}
              onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => { e.currentTarget.style.color = 'var(--mw-ink-secondary)' }}
            >
              {t('footer.contact')}
            </a>
          </nav>
        </div>
        <div
          className="mt-6 pt-5 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between"
          style={{ borderTop: '1px solid var(--mw-border)' }}
        >
          <p style={{ fontFamily: 'var(--mw-font-body)', fontSize: 12, color: 'var(--mw-ink-muted)', margin: 0 }}>
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
          <p style={{ fontFamily: 'var(--mw-font-body)', fontSize: 12, color: 'var(--mw-ink-muted)', margin: 0 }}>
            {t('footer.tagline')}
          </p>
        </div>
      </div>
    </footer>
  )
}
